import request from 'api/request';

export default function readEntryCodesRoute(courseId) {
  return request({ url: `/courses/${courseId}/codes` });
}
